const BASE_URL = 'https://vivasmart.com.mx';

// Build Basic Auth header: Base64('BROWSER:' + token)
export const buildBasicAuth = (token) => {
  const credentials = `BROWSER:${token}`;
  return `Basic ${btoa(credentials)}`;
};

export const getAuthHeaders = () => {
  const token = localStorage.getItem('vs_token');
  if (!token) return {};
  return {
    'Authorization': buildBasicAuth(token),
    'Content-Type': 'application/json',
  };
};

// Auth
export const signIn = async (email, password) => {
  const res = await fetch(`${BASE_URL}/v2/auth/signin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error('Credenciales incorrectas');
  return res.json();
};

// Planning list — los params del caller sobreescriben los defaults
export const getPlanningList = async (params = {}) => {
  const defaults = {
    order_by: 'from_date.desc',
    column: 'from_date',
    direction: 'desc',
    limit: 25,
    offset: 0,
    embed: 'crops,crops.crop,products,products.product',
    __logic: 'AND',
  };
  // merge: defaults primero, luego params del caller (caller gana)
  const merged = { ...defaults, ...params };
  const query = new URLSearchParams(merged).toString();
  const res = await fetch(`${BASE_URL}/v2/planning_list?${query}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Error al cargar planeaciones');
  return res.json();
};

// Planning detail — actividades de una planeación existente
export const getPlanningDetail = async (planningId) => {
  const res = await fetch(
    `${BASE_URL}/v2/planning/activity?planning_id=${planningId}&embed=activity,days`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error('Error al cargar el detalle de la planeación');
  return res.json();
};

// Weeks catalog — devuelve 1 semana atrás + 5 adelante (6 en total)
export const getWeeks = async (businessUnitId) => {
  const res = await fetch(
    `${BASE_URL}/v2/planning/week?business_unit_id=${businessUnitId}&limit=100&__logic=AND&order_by=from_date.desc`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error('Error al cargar semanas');
  const data = await res.json();
  const list = Array.isArray(data) ? data : data.data || [];

  // Ordenar ascendente por fecha para encontrar posición relativa a hoy
  const sorted = [...list].sort((a, b) => new Date(a.from_date) - new Date(b.from_date));
  const today = new Date();

  // Índice de la semana "actual" (la primera cuyo to_date >= hoy)
  let currentIdx = sorted.findIndex(w => new Date(w.to_date) >= today);
  if (currentIdx === -1) currentIdx = sorted.length - 1;

  // 1 atrás, semana actual + 5 adelante = ventana de 7 máximo
  const start = Math.max(0, currentIdx - 1);
  const end = Math.min(sorted.length, currentIdx + 6); // +6 porque slice es exclusivo en end
  return sorted.slice(start, end).reverse(); // más reciente primero para el select
};

// Lots list
export const getLots = async (businessUnitId) => {
  const res = await fetch(
    `${BASE_URL}/v2/lot_list?business_unit_id=${businessUnitId}&limit=100`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error('Error al cargar lotes');
  return res.json();
};

// Activities minify
export const getActivities = async (activityAreaId, businessUnitId, cropId) => {
  const res = await fetch(
    `${BASE_URL}/v2/activity/minify?activity_area_id=${activityAreaId}&business_unit_id=${businessUnitId}&crop_id=${cropId}`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error('Error al cargar actividades');
  return res.json();
};

// Create planning bulk
export const createPlanningBulk = async (payload) => {
  const res = await fetch(`${BASE_URL}/v2/planning/activity/bulk`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Error al guardar planeación');
  return res.json();
};

// Update planning bulk
export const updatePlanningBulk = async (planningId, bulk) => {
  const res = await fetch(`${BASE_URL}/v2/planning/activity/bulk/${planningId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ bulk }),
  });
  if (!res.ok) throw new Error('Error al actualizar planeación');
  return res.json();
};

export const BUSINESS_UNITS = [
  { id: 1, name: 'Culiacán' },
  { id: 2, name: 'Ensenada' },
  { id: 6, name: 'San Carlos' },
];
